import React from "react";
import { useLocation } from "react-router-dom";

const StaticPage = () => {
  const { state } = useLocation();
  const userName = state?.userName;

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="uacontainer">
        <p className="unp">
          {userName ? (
            <>
              This job is currently in use by another user{" "}
              <b>{userName}</b>. Please try again later.
            </>
          ) : (
            <>Something went wrong. Please try again.</>
          )}
        </p>
      </div>
    </div>
  );
};

export default StaticPage;
